export interface IUser {
    username: string | null,
    password: string | null,
    age: number | null
}

export interface IConditionToBlog {
    columnEqs: Array<{
        column: string,
        value: string
    }>
}

export enum BlogConditionStrategies {
    BY_CATEGORY = 'BY_CATEGORY',
    BY_TAG = 'BY_TAG'
}